export const DEFAULT_ILLUSTRATION_SIZE = 256;
export const IllustrationSize = {
  EXTRA_SMALL: 200,
  SMALL: 240,
  MEDIUM: DEFAULT_ILLUSTRATION_SIZE
};